import { render, staticRenderFns } from "./AssetUploader.vue?vue&type=template&id=1d52f079&"
import script from "./AssetUploader.vue?vue&type=script&lang=js&"
export * from "./AssetUploader.vue?vue&type=script&lang=js&"
import style0 from "./AssetUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports